import { css } from 'lit';

export const skeletonStyles = css`
    @keyframes shimmer {
        100% {
            -webkit-mask-position: left;
        }
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .skeleton {
        -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%;
        background-repeat: no-repeat;
        animation: shimmer 2.5s infinite;
    }

    .skeleton-block {
        background-color: var(--color-surface-accent);
        border-radius: var(--metrics-radius-s);
    }

    .skeleton-circle {
        background-color: var(--color-surface-accent);
        border-radius: 50%;
    }

    .hydrated > * {
        animation: fadeIn 0.3s ease-in;
    }
`;
